// extracted by mini-css-extract-plugin
export default {"label":"SWTemplateSpecialFields_label__XbHYz","row":"SWTemplateSpecialFields_row__OR4j9","minusIcon":"SWTemplateSpecialFields_minusIcon__oA23Q"};